import logo from '../../Assets/Img/Logo.png';
import './Header2.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';





function HeaderPlataforma() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header-plataforma">
      <div className="header-contenedor">

        {/* Logo (SIN badge, original) */}
        <div className="logoo">
          <img src={logo} className="logoo-img" alt="Tresatec" />
        </div>

        {/* Navegación */}
        <nav className={`nav ${isOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link to="/PlataformaEducativa" className="nav-pill" onClick={closeMenu}>
                Plataforma
              </Link>
            </li>
            <li>
              <Link to="/gestionadministrativa" className="nav-pill" onClick={closeMenu}>
                Gestion Administrativa
              </Link>
            </li>
            <li>
              <Link to="/Pedagogia" className="nav-pill" onClick={closeMenu}>
                Pedagogía
              </Link>
            </li>
            <li>
              <Link to="/Comunicacion" className="nav-pill" onClick={closeMenu}>
                Comunicación
              </Link>

            </li>
          </ul>

          {/* CTAs */}
          <div className="nav-cta">
            <Link to="/" className="nav-pill secondary" onClick={closeMenu}>
              ← Conocer Tresatec
            </Link>

            <a
              href='https://wa.me/message/ORWIOZ4UP74NM1' target="_blank"
              rel="noopener noreferrer"
              className="nav-pill cta"
              onClick={closeMenu}
            >
              Solicitar demo
            </a>
          </div>
        </nav>

        {/* Hamburger */}
        <div
          className={`hamburger ${isOpen ? 'open' : ''}`}
          onClick={toggleMenu}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>

        </div>
      </div>
    </header>
  );
}

export default HeaderPlataforma;
